import { useQuery } from "@tanstack/react-query";
import { getUser } from "../api";

export const useGetUser = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["USER"],
    queryFn: getUser,
    select: ({ data }) => data,
  });

  return { user: data, isLoading };
};
